---
meta:
  - title: Compartir agentes - IUSPRO Docs
  - description: Aprenda cómo compartir agentes dentro de una organización y qué permisos puede dar.
---

# Compartir agentes

Compartir agentes está pensado para equipos que trabajan dentro de una **organización**.

Si usted trabaja solo y no forma parte de una organización, esta parte no le aplica.

## Qué significa compartir un agente

Compartir un agente permite que otras personas de su organización puedan usarlo o editarlo, según el permiso que usted
les dé.

Esto sirve cuando:

- varias personas del despacho trabajan asuntos parecidos
- quiere dejar un criterio de trabajo listo para que otros lo usen
- necesita que un agente lo mantenga más de una persona

## Dos permisos importantes

### Ejecutar

Permite:

- ver el agente
- ejecutarlo
- revisar cómo está armado

### Editar

Permite todo lo anterior, más modificarlo.

## Cuándo conviene compartir solo para ejecutar

Úselo cuando:

- el agente ya quedó listo
- otras personas solo deben usarlo
- no quiere que cambien su estructura

## Cuándo conviene compartir para editar

Úselo cuando:

- varias personas construyen el agente
- todavía se está afinando
- el equipo necesita mantenerlo entre varias manos

## Qué conviene revisar antes de compartir

Antes de compartir, revise:

- que el nombre sea claro
- que la información que pide se entienda bien
- que las instrucciones estén bien redactadas
- que otra persona del equipo pueda usarlo sin que usted se lo explique

## Consejo práctico

Si va a compartir un agente con otras personas del despacho, procure que pida poca información y que el resultado
esperado sea muy claro.

Eso reduce errores y hace más fácil reutilizarlo.

## Siguiente lectura

- Lea [buenas prácticas para diseñar agentes](/guias/agentes-buenas-practicas)
